/** Engine slot 0|1 whose turn it is (from game state). */
export function getActiveEngineSlotFromState(
  gameSlug: string,
  gameState: unknown,
): 0 | 1 {
  if (gameSlug === 'classic-chess') {
    const fen = (gameState as { fen?: string }).fen;
    if (typeof fen === 'string' && fen.length > 0) {
      return fen.split(' ')[1] === 'w' ? 0 : 1;
    }
    return 0;
  }
  const s = gameState as { currentPlayer?: 0 | 1 };
  if (s.currentPlayer === 0 || s.currentPlayer === 1) {
    return s.currentPlayer;
  }
  return 0;
}
